import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map, pluck, skip, tap, withLatestFrom } from 'rxjs/operators';

import { CurrentUserEntityActions, CurrentUserSelectors } from '@recruitee/account-data';

import { Account } from '../services/account';
import { AccountActions, AccountSelectors } from './account.state';

@Injectable({ providedIn: 'root' })
export class AccountEffects {
  public deleteAccountRequest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AccountActions.deleteRequest),
        map(action => this.account.deleteAccountRequest(action.payload)),
      ),
    { dispatch: false },
  );

  public setDefaultTimezone$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CurrentUserEntityActions.fetchSuccess, CurrentUserEntityActions.updateSuccess),
        tap(action => this.account.setDefaultTimezone(action.payload.timezone)),
      ),
    { dispatch: false },
  );

  public changeCompany$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AccountActions.changeCompany),
        withLatestFrom(this.store.pipe(select(AccountSelectors.currentCompany))),
        tap(([{ payload: company }, currentCompany]) => {
          this.account.changeCompany(currentCompany!, company);
        }),
      ),
    { dispatch: false },
  );

  public redirectToBlockedAccount$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AccountActions.redirectToBlockedAccount),
        tap(() => this.account.redirectToBlockedAccount()),
      ),
    { dispatch: false },
  );

  public reloadAfterLanguageChange$ = createEffect(
    () =>
      this.store.select(CurrentUserSelectors.data).pipe(
        pluck('preferredLanguage'),
        distinctUntilChanged(),
        skip(1),
        tap(() => this.account.reloadApp()),
      ),
    { dispatch: false },
  );

  public signOut$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AccountActions.signOut),
        tap(({ payload }) => this.account.signOut(payload?.afterSignOutUrl)),
      ),
    { dispatch: false },
  );

  constructor(
    private account: Account,
    private actions$: Actions,
    private store: Store,
  ) {}
}
